import { Outlet } from 'react-router-dom'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AppSidebar } from './AppSidebar'
import { AppHeader } from './AppHeader'
import { DemoBanner } from './DemoBanner'
import { MaintenanceMode } from '@/components/shared/MaintenanceMode'
import { DebugPanel } from '@/components/dev/DebugPanel'
import { AlertBannerSystem } from '@/components/alerts/AlertBannerSystem'
import { MobileNavigation } from '@/components/mobile/MobileNavigation'
import { useMobileResponsive } from '@/hooks/useMobileResponsive'

export function AppLayout() {
  const { isMobile } = useMobileResponsive()

  if (isMobile) {
    return (
      <div className="min-h-screen bg-background">
        <DemoBanner />
        <MobileNavigation>
          <MaintenanceMode />
          <AlertBannerSystem />
          <main className="min-h-screen">
            <Outlet />
          </main>
          <DebugPanel />
        </MobileNavigation>
      </div>
    )
  }

  return (
    <div className="h-screen bg-background">
      <DemoBanner />
      <SidebarProvider>
        <MaintenanceMode />
        <AlertBannerSystem />
        <div className="h-full flex w-full">
          <AppSidebar />
          <div className="flex-1 flex flex-col min-w-0">
            <AppHeader />
            <main className="flex-1 overflow-y-auto overflow-x-hidden bg-background">
              <div className="container-fluid max-w-full px-4 sm:px-6 lg:px-8 py-6 min-w-0">
                <Outlet />
              </div>
            </main>
          </div>
          <DebugPanel />
        </div>
      </SidebarProvider>
    </div>
  )
}